import {
  Button,
  Tooltip,
  TextField,
  MenuItem,
  ButtonGroup,
  Chip,
  Autocomplete,
  Checkbox,
} from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useSelector } from "react-redux";
import { QuickSearchToolbarProps } from "./types";
import { RootState } from "../../store/store";
import { dateFormatter } from "../schedule/AddScheduleOrder";
import DownloadIcon from "@mui/icons-material/Download";
import { useState } from "react";
import { truncateText } from "../../utils/truncateText";
import theme from "../../Themes";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DateTime } from "luxon";
import titleCase from "../../utils/titleCase";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const LargeScreenTableSearch = (props: QuickSearchToolbarProps) => {
  const { isMobileView, masterLocation } = useSelector(
    (state: RootState) => state.globalAppState
  );

  const { filterData } = useSelector(
    (state: RootState) => state.steelShortageReportsState
  );

  const [value, setValue] = useState<string[] | []>([]);

  const { onDownload, shortageData, setShortageData } = props;

  const updateData = (
    value: string | number | string[],
    name: any,
    event?: any
  ) => {
    if (name === "code") {
      // @ts-ignore
      if (value.find((str: any) => str === "All")) value = [];
    }
    if (name === "startDate" || name === "endDate") {
      if (event) value = event.toISODate();
      else value = "";
    }
    setShortageData({ ...shortageData, [name]: value !== "All" ? value : "" });
  };

  const renderTags = (value: any, getTagProps: any) => {
    if (value.length === 0) {
      return null;
    }

    const totalSelectedCount = value.length - 1;
    const firstOption = value[0];

    return (
      <>
        <Chip
          label={truncateText(firstOption, 7)}
          {...getTagProps({ index: 0 })}
          size="small"
        />
        {totalSelectedCount > 0 ? <span>{`+${totalSelectedCount}`}</span> : ""}
      </>
    );
  };

  const clearAllFilters = () => {
    setValue([]);
    setShortageData({
      name: "",
      code: [],
      shortageRange: "",
      probability: "75 - 100",
      startDate: "",
      endDate: "",
      location: masterLocation.locationId,
    });
  };
  if (filterData?.allowedLocations?.length) {
    return (
      <Box display={"flex"} alignItems={"center"}>
        <Box p={2} className={isMobileView ? "mobileViewCls" : "normalFilter"}>
          <Box className={"resp-select"}>
            <Autocomplete
              multiple
              id="checkboxes-tags-code"
              size="small"
              options={filterData?.code}
              disableCloseOnSelect
              getOptionLabel={(option: string) => option}
              value={value}
              limitTags={1}
              onChange={(event: any, newValue: string[]) => {
                setValue(newValue);
                updateData(newValue, `code`);
              }}
              renderTags={renderTags}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginLeft: "-10px" }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      width: "226px",
                      height: "35px",
                      fontSize: "14px",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: "14px",
                    },
                  }}
                  label="Code"
                />
              )}
            />
          </Box>
          <Box className={"resp-select"}>
            <TextField
              type="text"
              name="name"
              label={`Product Name`}
              select
              variant="outlined"
              fullWidth
              // asd
              value={shortageData?.name}
              onChange={(e) => updateData(e.target.value, e.target.name)}
              size="small"
              InputProps={{
                sx: {
                  width: "108px",
                  height: "35px",
                  fontSize: "14px",
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: "14px",
                },
              }}
            >
              {filterData?.names?.length ? (
                <MenuItem value={"All"}>None</MenuItem>
              ) : (
                "no data"
              )}
              {filterData?.names?.map((option: any, i: number) => (
                <MenuItem key={i} value={Object.values(option)[0]}>
                  {/* @ts-ignore */}
                  {Object.values(option)[0]}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box className={"resp-select"}>
            <TextField
              type="text"
              name="shortageRange"
              label={`Range`}
              select
              variant="outlined"
              fullWidth
              value={shortageData?.shortageRange}
              onChange={(e) => updateData(e.target.value, e.target.name)}
              InputProps={{
                sx: {
                  width: "108px",
                  height: "35px",
                  fontSize: "14px",
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: "14px",
                },
              }}
              size="small"
            >
              <MenuItem value={"All"}>None</MenuItem>
              <MenuItem value={"gt0"}>Above Zero</MenuItem>
              <MenuItem value={"0"}>Zero</MenuItem>
              <MenuItem value={"lt0"}>Below Zero</MenuItem>
            </TextField>
          </Box>
          <Box className={"resp-select"}>
            <TextField
              type="text"
              name="probability"
              label={`Probability %`}
              select
              variant="outlined"
              fullWidth
              value={shortageData?.probability}
              onChange={(e) => updateData(e.target.value, e.target.name)}
              size="small"
              InputProps={{
                sx: {
                  width: "108px",
                  height: "35px",
                  fontSize: "14px",
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: "14px",
                },
              }}
            >
              <MenuItem value={"None"}>None</MenuItem>
              <MenuItem value={"100"}>100%</MenuItem>
              <MenuItem value={"75 - 100"}>75% - 100%</MenuItem>
              <MenuItem value={"Below 75"}>Below 75%</MenuItem>
            </TextField>
          </Box>

          <Box>
            <LocalizationProvider dateAdapter={AdapterLuxon}>
              <DatePicker
                label="Start Date"
                format="dd/MM/yyyy"
                value={
                  shortageData?.startDate
                    ? DateTime.fromJSDate(new Date(shortageData?.startDate))
                    : null
                }
                slotProps={{
                  textField: {
                    size: "small",
                    InputProps: {
                      sx: {
                        width: "108px",
                        height: "35px",
                        fontSize: "14px",
                      },
                    },
                    InputLabelProps: {
                      sx: {
                        fontSize: "14px",
                      },
                    },
                  },
                  actionBar: {
                    actions: ["clear"],
                  },
                }}
                onChange={(e: any) => updateData("", "startDate", e)}
              />
            </LocalizationProvider>
          </Box>
          <Box>
            <LocalizationProvider dateAdapter={AdapterLuxon}>
              <DatePicker
                label="End Date"
                format="dd/MM/yyyy"
                value={
                  shortageData?.endDate
                    ? DateTime.fromJSDate(new Date(shortageData?.endDate))
                    : null
                }
                slotProps={{
                  textField: {
                    size: "small",
                    InputProps: {
                      sx: {
                        width: "108px",
                        height: "35px",
                        fontSize: "14px",
                      },
                    },
                    InputLabelProps: {
                      sx: {
                        fontSize: "14px",
                      },
                    },
                  },
                  actionBar: {
                    actions: ["clear"],
                  },
                }}
                onChange={(e: any) => updateData("", "endDate", e)}
              />
            </LocalizationProvider>
          </Box>
          <Box className={"resp-select"}>
            <TextField
              type="text"
              name="location"
              label={`Location`}
              select
              variant="outlined"
              fullWidth
              value={shortageData?.location}
              onChange={(e) => updateData(e.target.value, e.target.name)}
              size="small"
              InputProps={{
                sx: {
                  width: "108px",
                  height: "35px",
                  fontSize: "14px",
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: "14px",
                },
              }}
            >
              {filterData?.location?.length ? (
                <MenuItem value={"all"}>All</MenuItem>
              ) : (
                <MenuItem value={""}></MenuItem>
              )}
              {filterData?.location?.length ? (
                filterData?.location?.map((option: any, i: number) => (
                  <MenuItem key={i} value={option._id}>
                    {titleCase(option.fullName)}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value={""}></MenuItem>
              )}
            </TextField>
          </Box>
          <Box className={"resp-select"}>
            <Button
              variant="outlined"
              onClick={clearAllFilters}
              sx={{
                width: "108px",
                height: "35px",
                fontSize: "14px",
                color: theme.palette.indicator.main,
              }}
            >
              Clear All
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            flex: "1",
            display: "flex",
            justifyContent: "end",
            marginBottom: "15px",
          }}
        >
          <ButtonGroup aria-label="outlined primary button group">
            <Tooltip title="Download Report">
              <Button
                color="primary"
                variant="contained"
                onClick={onDownload}
                sx={{
                  width: "54px",
                  height: "35px",
                }}
              >
                <DownloadIcon />
              </Button>
            </Tooltip>
          </ButtonGroup>
        </Box>
      </Box>
    );
  }
  return <></>;
};

export const ShortageReportFilter = (props: QuickSearchToolbarProps) => {
  return (
    <Box>
      <LargeScreenTableSearch {...props} />
    </Box>
  );
};
